import React, { useState } from "react";
import {createContext} from 'react';
import { EComponentName } from "../../common/enum/EComponentName";
const SnackbarContext = createContext({
    msg: "",
    name:EComponentName.NotMentioned,
    isDisplayed: false,
    displayMsg: (msg,name) => { },
    onClose: () => { },
});
export default SnackbarContext;